import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { FormGroup, Col, Label } from 'reactstrap'
import { DatePicker } from '@/components/DatePicker'
import AssigneeSelector from '@/components/AssigneeSelector'
import Resx from '@/components/Resx'
import { Validator } from '@/components/validation'
import { ValidationContext } from '@/components/validation/validationContext'

function MakerCheckerInputs (props) {
  const { value, onChange } = props
  const { makerUser, makerUserId, dueDate } = value
  const validationContext = useContext(ValidationContext)

  MakerCheckerInputs.propTypes = {
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }

  // Clear dependant fields
  useEffect(() => {
    validationContext.resetErrors(['companyId', 'reportGroupSubmissionId', 'bankId'])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <FormGroup row>
      <Label sm='2' className='label'><Resx name='Tickets.Assignee' /></Label>
      <Col sm='4'>
        <Validator name='makerUserId' value={makerUserId} required>
          <AssigneeSelector
            value={makerUser}
            onChange={user => onChange({ ...value, makerUserId: user ? user.id : null, makerUser: user })}
          />
        </Validator>
      </Col>
      <Label sm='2' className='label'><Resx name='Tickets.DueDate' /></Label>
      <Col sm='4'>
        <DatePicker
          value={dueDate}
          onChange={value => onChange({ ...value, dueDate: value })} />
      </Col>
    </FormGroup>
  )
}

export {
  MakerCheckerInputs
}



// WEBPACK FOOTER //
// ./src/dialogs/ticketTypes/makerChecker.js